import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(c1, r1, sImaginary) {
  var result = Complex.createComplex(1, 0).divide(Complex.createComplex(1, r1 * c1 * sImaginary));
  return result;
}

export function computeComplexFF() {
  var result = Complex.createComplex(0, 0);
  return result;
}
